<h1 mat-dialog-title>
    <span [translate]="'admin.frais.prestations.detail.reglesGestion.remboursement.bareme.popin.' + (bareme.idBareme ? 'modification' : 'creation')"></span>
    <span [mat-dialog-close]><i class="zmdi zmdi-close"></i></span>
</h1>
<div mat-dialog-content>
    <form #form="ngForm" style="height: 200px;">
        <div class="row">
            <custom-input ngDefaultControl
                          id="dateAppli"
                          name="dateAppli"
                          [ngModel]="bareme.dateAppli"
                          [(customModel)]="bareme.dateAppli"
                          customType="date"
                          lCol="3"
                          rCol="3"
                          (onChange)="onDateChange()"
                          libelle="admin.frais.prestations.detail.reglesGestion.remboursement.bareme.popin.dateApplication"
                          [required]=" true"
                          [disabled]="isEdition">
            </custom-input>
            <custom-input ngDefaultControl
                          id="taux"
                          name="taux"
                          [(ngModel)]="bareme.taux"
                          customType="number"
                          lCol="3"
                          rCol="3"
                          [max]="999.999"
                          [nbDecimales]="3"
                          libelle="admin.frais.prestations.detail.reglesGestion.remboursement.bareme.popin.taux"
                          [required]=" true">
            </custom-input>
        </div>
        <div class="row">
            <custom-input ngDefaultControl
                          id="valeurMini"
                          name="valeurMini"
                          [(ngModel)]="bareme.mini"
                          customType="number"
                          lCol="3"
                          rCol="3"
                          [max]="999999"
                          [suffix]="data.unite"
                          libelle="admin.frais.prestations.detail.reglesGestion.remboursement.bareme.popin.valeurMini"
                          [disabled]="true"
                          [required]=" true">
            </custom-input>
            <custom-input ngDefaultControl
                          id="valeurMaxi"
                          name="valeurMaxi"
                          [(ngModel)]="bareme.maxi"
                          customType="number"
                          lCol="3"
                          rCol="3"
                          [min]="isLastTranche ? 0 : ((bareme.mini || 0) + 1)"
                          [max]="999999"
                          [suffix]="data.unite"
                          libelle="admin.frais.prestations.detail.reglesGestion.remboursement.bareme.popin.valeurMaxi"
                          [required]=" true">
            </custom-input>
        </div>
        <div *ngIf="data.typeBareme == TypeBareme.BAREME_SNCF" class="row">
            <custom-input ngDefaultControl
                          id="constante"
                          name="constante"
                          [(ngModel)]="bareme.constante"
                          customType="number"
                          lCol="3"
                          rCol="3"
                          [max]="999.99"
                          [nbDecimales]="2"
                          libelle="admin.frais.prestations.detail.reglesGestion.remboursement.bareme.popin.constante"
                          [required]=" true">
            </custom-input>
        </div>
    </form>
</div>
<div mat-dialog-actions>
    <button mat-stroked-button color="warn" *ngIf="bareme.idBareme && !isLastTranche" (click)="onDelete()" [disabled]="isPending"><span [translate]="'global.actions.supprimer'"></span></button>
    <button mat-flat-button color="primary" (click)="onSave()" [disabled]="form?.invalid || isPending"><span [translate]="'global.actions.enregistrer'"></span></button>
</div>